import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/startpage-logged-out/entry/src/recruiters-section/assets/huseyin-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')